import { Component, computed, inject, input, InputSignal, OnDestroy, Signal, signal, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CapacityLabelPayload, CapacityLabelPayloadSchema } from '../models';
import { IqEventBusBrokerHandler, IqEventBusBrokerService } from '@dat/iq-event-bus';
import { MCDashboardIds } from '@dat/iq-mc-utils';

@Component({
    selector: 'iq-mc-label-capacity',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './iq-mc-label-capacity.component.html',
    styleUrl: './iq-mc-label-capacity.component.scss',
})
export class IqMcLabelCapacityComponent implements OnDestroy {
    id: InputSignal<string> = input('');

    private _payload: WritableSignal<CapacityLabelPayload> = signal({
        id: '',
        primaryLabel: '',
        secondaryLabel: '',
        showSecondaryLabel: false,
    });

    displaySecondaryLabel: Signal<boolean> = computed(() => {
        return this._payload().showSecondaryLabel || false;
    });

    primaryLabel: Signal<string> = computed(() => {
       return this._payload().primaryLabel;
    });

    secondaryLabel: Signal<string> = computed(() => {
        return this._payload().secondaryLabel || '';
    });

    closeSearchId: Signal<string> = computed(() => {
        if (this.id() === MCDashboardIds.DoubleSearchDashboardLeft) return 'Cy-MC-CloseSearchLeft-Button'
        if (this.id() === MCDashboardIds.DoubleSearchDashboardRight) return 'Cy-MC-CloseSearchRight-Button';
        return 'Cy-MC-CloseSearch-Button';
    });

    private _deregisterMap: Record<string, IqEventBusBrokerHandler> = {};

    private _bus: IqEventBusBrokerService = inject(IqEventBusBrokerService);

    constructor() {
        this._deregisterMap = this._bus.registerMap({
            setMcGaugeLabel: {
                callback: (payload: CapacityLabelPayload) => {
                    const test: any = CapacityLabelPayloadSchema.safeParse(payload);

                    if(payload.id !== this.id()) return;

                    if (!test.success) {
                        console.warn('SetMcTitleLabel Invalid Payload');
                        console.log(test?.error?.issues);
                        return;
                    }

                    this._payload.set(payload);
                },
            },
        });
    }

    closeSearch(): void {
        this._bus.dispatch({
            name: 'type:mc:close:dashboard',
            payload: {
                id: this.id(),
            }
        })
    }

    ngOnDestroy(): void {
        this._bus.unregisterMap(this._deregisterMap);
    }
}
